<template>
  <form @submit.prevent="onSubmit" class="clm-form__form">

    <a-layout :line-type="'auth'" @go="goAuth" :title-text="$t('auth-form-create.titleText')" @close="$emit('close')">
      <div v-if="!serverSuccess">
        <div class="clm-form__inputs-block">

          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'acr-name'"
              :input-type="'text'"
              :input-name="'name'"
              :class-name="'name'"
              :placeholder="$t('auth-form-create.placeholderName')"
              :err-msg="$t('auth-form-create.errorNameEmpty')"
              :is-valid="cFormNameValid"
              :is-invalid="formNameInvalid"
              v-model="formName"
          >{{$t('auth-form-create.labelName')}}
          </auth-form-input>

          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'acr-email'"
              :input-type="'email'"
              :input-name="'login'"
              :class-name="'email'"
              :placeholder="'youremailadress@mail.ru'"
              :err-msg="(formEmail.length > 0) ? $t('auth-form-create.errorEmailFormat') : $t('auth-form-create.errorEmailEmpty')"
              :is-valid="cFromEmailValid"
              :is-invalid="formEmailInvalid"
              v-model="formEmail"
          >{{$t('auth-form-create.labelEmail')}}
          </auth-form-input>

          <auth-form-input
              @submit="onSubmit"
              :is-requared="false"
              :id="idPrefix + 'acr-phone'"
              :input-type="'tel'"
              :input-name="'phone'"
              :class-name="'tel'"
              :placeholder="'+7 (999) 999-99-99'"
              :err-msg="$t('auth-form-create.errorPhoneFormat')"
              :is-valid="cFormPhoneValid"
              :is-invalid="formPhoneInvalid"
              v-model="formPhone"
              :is-masked-phone="true"
          >{{$t('auth-form-create.labelPhone')}}
          </auth-form-input>

          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'acr-pass'"
              :input-type="(showPassword) ? 'text' : 'password'"
              :input-name="'password'"
              :class-name="'password'"
              :placeholder="$t('auth-form-create.placeholderPass')"
              :err-msg="(formPass1.length > 0) ? cPassErr : $t('auth-form-create.errorPassEmpty')"
              :is-valid="cFormPassValid || cFormPassFirstValid"
              :is-invalid="formPassInvalid"
              :show-pass-btn="true"
              :is-visible="showPassword"
              @pass:show="showPassword = true"
              @pass:hide="showPassword = false"
              v-model="formPass1"
          >{{$t('auth-form-create.labelPass')}}
          </auth-form-input>
          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'acr-pass2'"
              :input-type="(showPassword) ? 'text' : 'password'"
              :input-name="'password'"
              :class-name="'password'"
              :placeholder="$t('auth-form-create.placeholderRepeatPass')"
              :err-msg="(formPass2.length > 0) ? cPassErr : $t('auth-form-create.errorPassEmptyRepeat')"
              :is-valid="cFormPassValid"
              :is-invalid="formPassInvalid"
              :is-visible="showPassword"
              v-model="formPass2"
          >{{$t('auth-form-create.labelRepeatPass')}}
          </auth-form-input>

        </div>
        <a-report :is-error="true" v-if="serverError">
          Внимание! {{serverError}}
        </a-report>
        <div class="clm-form-btns">
          <a-submit-btn :is-disabled="!cFormValid" @action="onSubmit" :is-loading="formProcess">{{$t('auth-form-create.submitText')}}</a-submit-btn>
        </div>
        <a-agreement>{{$t('auth-form-create.submitText')}}</a-agreement>
      </div>
      <div v-else>
        <div class="clm-form-text">
          <div class="clm-form-text__title">
            {{$t('auth-form-create.afterSendingText0')}}
          </div>
          <div class="clm-form-text__subtitle">
            <p>
              {{$t('auth-form-create.afterSendingText1')}}
            </p>
            <p>
              {{$t('auth-form-create.afterSendingText2')}}
            </p>
          </div>
        </div>
        <div class="clm-form-btns">
          <a-submit-btn :is-outline="true" @action="onResending" :is-loading="formProcess">{{$t('auth-form-create.resendEmail')}}</a-submit-btn>
        </div>
      </div>
    </a-layout>
  </form>
</template>

<script>
import aReport from './a-report.vue'
import authFormInput from "../auth-form-input.vue"
import aAgreement from './a-agreement.vue'
import aSubmitBtn from './a-submit-btn.vue'

import aLayout from './a-layout.vue'

import validate from '../../../scripts/validate'
import createPassError from "../../../scripts/createPassError";

export default {
  name: "auth-form-create",
  components: {
    aReport,
    aAgreement,
    aSubmitBtn,
    authFormInput,
    aLayout
  },
  props: {
    idPrefix: String,
    pageParams: Object
  },
  emits: ['close', 'go:auth'],
  data() {
    return {
      submitText: 'Зарегистрировать аккаунт',
      titleText: 'Регистрация аккаунта',

      formName: '',
      formNameInvalid: false,

      formEmail: '',
      formEmailInvalid: false,

      formPhone: '',
      formPhoneInvalid: false,

      formPass1: '',
      formPass2: '',
      formPassInvalid: false,

      showPassword: false,

      formProcess: false,
      serverError: false,
      defaultErr: 'Ошибка в работе сайта. Попробуйте еще раз.',
      serverSuccess: false,

      freezeData: {},
    }
  },
  computed: {
    cFormNameValid() {
      return validate('noempty', this.formName)
    },
    cFromEmailValid() {
      return validate('email', this.formEmail)
    },
    cFormPhoneValid() {
      return validate('tel', this.formPhone)
    },
    cFormPassValid() {
      const valid = this.cFormPassFirstValid;
      return (valid && this.formPass1 === this.formPass2)
    },
    cFormPassFirstValid() {
      const params = this.pageParams.passPolicy;
      return validate('pass', this.formPass1, params)
    },
    cFormValid() {
      let phoneValid = true;
      if (this.formPhone.length > 0) {
        phoneValid = this.cFormPhoneValid
      }
      return (this.cFromEmailValid && this.cFromEmailValid && this.cFormPassValid && phoneValid)
    },
    cPassErr() {
      const pass1 = this.formPass1;
      const pass2 = this.formPass2;
      const params = this.pageParams.passPolicy;
      return createPassError(pass1, pass2, params)
    }
  },
  watch: {
    formEmail() {
      this.formEmailInvalid = false;
    },
    formName() {
      this.formNameInvalid = false;
    },
    formPass1() {
      this.formPassInvalid = false;
    },
    formPass2() {
      this.formPassInvalid = false;
    }
  },
  methods: {
    goAuth() {
      this.$emit('go:auth')
    },
    onResending() {
      if (this.formProcess) {
        return null;
      }
      this.formProcess = true;
      this.$api.registration(this.freezeData).then(() => {
        this.formProcess = false;
      }).catch((err) => {
        console.error('Ajax err')
        console.log(err)
        this.formProcess = false;
      })
    },
    onSubmit() {
      if (this.formProcess) {
        return null;
      }
      const props = [
        {name: 'formEmail', type: 'email'},
        {name: 'formName', type: 'noempty'},
      ]
      let noErr = true
      props.forEach(el => {
        if (!validate(el.type, this[el.name])) {
          this[el.name + 'Invalid'] = true;
          noErr = false;
        }
      })

      const pass1 = this.formPass1
      const pass2 = this.formPass2
      const passParams = this.pageParams.passPolicy;
      if (pass1 !== pass2 || !validate('pass', pass1, passParams)) {
        this.formPassInvalid = true;
        noErr = false;
      }

      if (this.formPhone.length > 0) {
        if (!validate('tel', this.formPhone)) {
          noErr = false;
          this.formPhoneInvalid = true;
        }
      }

      if (noErr) {
        this.formProcess = true;
        const FIO = this.formName.split(' ');
        const name = FIO.shift()
        const second = FIO.shift()
        const lastName = (second) ? second : '';
        const secondName = FIO.join(' ')

        const usrData = {
          'USER_NAME': name,
          'USER_LAST_NAME': lastName,
          'USER_SECOND_NAME': secondName,
          'USER_EMAIL': this.formEmail,
          'USER_LOGIN': this.formEmail,
          'USER_PASSWORD': this.formPass1,
          'USER_CONFIRM_PASSWORD': this.formPass2,
          'USER_PERSONAL_PHONE': this.formPhone,
        }
        this.freezeData = usrData;
        this.$api.registration(usrData).then(data => {
          const response = data.data;
          if (response.status) {
            console.log('Успешная регистрация')
            this.serverError = false;
            this.serverSuccess = true;
          } else {
            if (response.errors.length > 0) {
              this.serverError = response.errors.join('; ')
            } else {
              this.serverError = this.defaultErr
            }
          }
          this.formProcess = false;
        }).catch(err => {
          console.error('Ajax err')
          console.log(err)
          this.serverError = this.defaultErr
          this.formProcess = false;
        })
      }
    }
  }
}
</script>
